import BaseOption from "@/app/components/common-filter-builder/common-filters-components/base-checkbox/BaseOption";

interface Props {
  checked: boolean;
  toggleOption: () => void;
  is_multi_select: boolean;
  label: string;
}

const OneOption: React.FC<Props> = ({
  checked,
  toggleOption,
  is_multi_select,
  label,
}) => {
  return (
    <div
      onClick={toggleOption}
      className={`add-on ${checked ? "add-on-selected" : ""}`}
    >
      <BaseOption
        selected={checked}
        toggleOption={() => {}}
        is_multi_select={is_multi_select}
        label={label}
      />
    </div>
  );
};

export default OneOption;
